import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Mobile, Landscape } from "../Response";
const Footer = () => {
  const back = useSelector((state) => state.switch.back);
  return (
    <Container back={back} className={back === "sun" ? `white` : `black`}>
      <Left>
        <EachItem back={back}>
          <EmailOutlinedIcon className="iconsl" />
          <Links href="mailto: mariwanakrammohammed@gmail.com" back={back}>
            MariwanAkramMohammed@gmail.com
          </Links>
        </EachItem>
        <EachItem back={back}>
          <PinDropOutlinedIcon className="iconsl" />
          <Links back={back}>Sulaimany</Links>
        </EachItem>
        <EachItem back={back}>
          <CallOutlinedIcon className="iconsl" />
          <Links back={back} href="tel:07511828836">
            +964 751 182 8836
          </Links>
        </EachItem>
      </Left>
      <Right>
        <EachItem back={back}>
          <FacebookIcon className="icons" />
          <IconLinks back={back}>Mariwan A-Mohammed</IconLinks>
        </EachItem>
        <EachItem back={back}>
          <InstagramIcon className="icons" />
          <IconLinks back={back}>mariwan_akram</IconLinks>
        </EachItem>
        <EachItem back={back}>
          <LinkedInIcon className="icons" />
          <IconLinks back={back}>Mariwan-Zia</IconLinks>
        </EachItem>
        <EachItem back={back}>
          <TwitterIcon className="icons" />
          <IconLinks back={back}>Mariwan-A</IconLinks>
        </EachItem>
      </Right>
    </Container>
  );
};
export default Footer;
const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 30vh;
  // border-top: 3px solid gray;
  display: flex;
  justify-content: center;
  align-items: center;
  &.white {
    background-image: linear-gradient(
      to right,
      rgb(226, 235, 240),
      rgb(239, 245, 248),
      rgb(239, 245, 248),
      rgb(226, 235, 240)
    );
  }
  &.black {
    background-image: linear-gradient(
      to right,
      rgb(22, 28, 35, 0.3),
      rgb(22, 28, 35, 0.3),
      rgb(22, 28, 35, 0.8),
      #0d1116
    );
  }
  padding: 30px 50px 0px 50px;
  ${Mobile({ padding: "10px 10px 0px 10px", flexDirection: "column" })}
  ${Landscape({ height: "40vh", width: "100%", padding: 30 })}
`;
const Left = styled.div`
  flex: 2.5;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${Mobile({ flex: 1, height: "100%" })}
`;
const EachItem = styled.div`
  flex: 1;
  width: 80%;
  // background: gray;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  .icons {
    color: red;
    font-size: 30px;
    transition: all 0.6s;
    ${Landscape({ fontSize: 22, margin: 2 })}
    color: ${(props) =>
      props.back === "sun"
        ? "rgba(12, 12, 28, 0.35)"
        : " rgba(228, 236, 240, 0.5)"};
    cursor: pointer;
    ${Mobile({ fontSize: 18 })}
    &:hover {
      color: ${(props) =>
        props.back === "sun"
          ? "rgba(12, 12, 28, 0.4)"
          : " rgba(228, 236, 240, 0.7)"};
    }
  }
  .iconsl {
    font-size: 30px;

    color: ${(props) =>
      props.back === "sun"
        ? "rgba(12, 12, 28, 0.5)"
        : " rgba(228, 236, 240, 0.7)"};
    cursor: pointer;
  }

  ${Mobile({ gap: 5 })}
`;
const Links = styled.a`
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  letter-spacing: 1.6px;

  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.5)"
      : " rgba(228, 236, 240, 0.7)"};
  text-decoration: none;
  ${Mobile({ fontSize: 16, fontWeight: 600 })}
`;
const Right = styled.div`
  flex: 1;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: flex-start;
  ${Mobile({
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: "5px 20px 0px 20px",
    flex: 0.6,
  })}
  ${Landscape({ flex: 1.2 })}
`;
const IconLinks = styled.p`
  font-size: 15px;
  cursor: pointer;
  letter-spacing: 1.6px;
  ${Landscape({ letterSpacing: 1 })}
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.35)"
      : " rgba(228, 236, 240, 0.5)"};
  ${Mobile({ width: "120px", letterSpacing: 1 })}
`;
